import { render } from "./Complaint.vue?vue&type=template&id=6a2dcc7f&scoped=true"
import script from "./Complaint.vue?vue&type=script&lang=js"
export * from "./Complaint.vue?vue&type=script&lang=js"

import "./Complaint.vue?vue&type=style&index=0&id=6a2dcc7f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6a2dcc7f"

export default script